var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-3"},[_c('div',{staticClass:"w3-black"}),_c('div',{staticClass:"w3-grey bg-gradient-bar",style:({ width: _vm.progress + '%' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }